import { FC, useState } from 'react';
import { Text, TextProps } from '@chakra-ui/react';
export interface CbTextCollapseProps extends TextProps {
  maxCharacterLength?: number;
  numberOfLines?: number;
  text: string;
}
export const CbTextCollapse: FC<CbTextCollapseProps> = ({
  maxCharacterLength,
  numberOfLines = 1,
  text,
  ...props
}) => {
  const [noOfLines, setNoOfLines] = useState(numberOfLines);
  const [collapseText, setCollapseText] = useState('see more');
  const handleSeeMore = (text: string) => {
    if (text === 'see more') {
      setNoOfLines(100);
      setCollapseText('see less');
    } else {
      setNoOfLines(numberOfLines);
      setCollapseText('see more');
    }
  };
  return <>
      <Text fontSize="sm" color="text.secondary" {...props} noOfLines={noOfLines} data-sentry-element="Text" data-sentry-source-file="CbTextCollapse.tsx">
        {text}
      </Text>
      {maxCharacterLength && text?.length > maxCharacterLength && <Text as="button" fontSize="sm" color="spyro.600" fontWeight="semibold" onClick={() => handleSeeMore(collapseText)}>
          {collapseText}
        </Text>}
    </>;
};